export const markdown = `The **Sloyd API** is a RESTful API designed for seamless interaction with the Sloyd platform. It provides a simple and intuitive interface, utilizing standard HTTP methods and response codes.

## Getting Started

To begin using the Sloyd API, install the library by running the following command:

\`\`\`bash
npm install @sloyd/api
\`\`\`

After installation, import the library into your project:

\`\`\`typescript
import { SloydApi } from '@sloyd/api';
\`\`\`

### Authentication

You will need an API key to authenticate your requests. Obtain your API key by signing up for an account on the Sloyd platform. Once you have the key, initialize the API:

\`\`\`typescript
import { init } from '@sloyd/api';

init({
  apiKey: 'XXX-XXX-XXX-XXX',
});
\`\`\`

## Features

- **Rapid Deployment**  
  Deploy advanced 3D generation capabilities effortlessly by integrating a few lines of code. Instantly generate 3D models from simple text prompts to enhance your application's functionality and user experience.

- **Instant 3D Models**  
  Generate 3D models in real time from text prompts. Empower your applications with cutting-edge 3D model creation without requiring extensive backend infrastructure.

- **Universal Compatibility**  
  Integrate seamlessly with any software or platform. The Sloyd API provides versatile 3D creation capabilities to enhance a wide range of applications.

- **Customizable Outputs**  
  Adjust and customize generated 3D models to meet your specific requirements. Achieve seamless integration with your projects by tailoring the models to fit your exact needs.

- **Predictable Pricing**  
  Enjoy transparent pricing based on API usage. Only pay for the API calls you make. Contact our team for detailed pricing tailored to your project's requirements.

---

For more details, visit our [official documentation](https://sloyd.gitbook.io/documentation).
`;

